import $ from 'jquery';
import PayLaterBaseMessage from "./PayLaterBaseMessage";

class PayLaterCheckoutMessage extends PayLaterBaseMessage {
    constructor(props) {
        super(props);
        this.cart = props.cart;
        this.promises = [];
    }

    initialize() {
        this.actions.addAction('updated_checkout', super.initialize.bind(this), 20);
        $(document.body).on('update_checkout', this.updateCheckout.bind(this));
        super.initialize();
    }

    updateCheckout() {
        this.promises.push(
            new Promise(resolve => {
                $(document.body).one('updated_checkout', () => {
                    resolve();
                });
            })
        )
    }

    async createMessage() {
        await Promise.all(this.promises);
        this.promises = [];
        super.createMessage();
    }

    getMessageContainer() {
        const fk = this.getSetting('checkoutLocation');
        let el;
        switch (fk) {
            case 'shop_table':
                el = document.getElementById('wc-ppcp-paylater-msg-checkout');
                break;
            case 'above_button':
                el = document.querySelector('.wc-ppcp-checkout-container');
                if (el) {
                    $(el).find('#wc-ppcp-paylater-msg-checkout').remove();
                    $(el).prepend('<div id="wc-ppcp-paylater-msg-checkout"></div>');
                    el = document.getElementById('wc-ppcp-paylater-msg-checkout');
                } else {
                    setTimeout(this.createMessage.bind(this), 500);
                }
        }
        return el;
    }

    getPlacement() {
        return 'payment';
    }

    getTotal() {
        return this.cart.getTotal();
    }
}

export default PayLaterCheckoutMessage;

export {PayLaterCheckoutMessage}
